import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class CloseButton extends Component {
    render() {
        const { className, styles, to, onClick, isLink } = this.props;
        const defaultStyles = {
            position: "absolute",
            top: 20,
            right: 20,
            color: '#000000',
            fontSize: '16px',
            border: '1px #5b5b5b solid',
            borderRadius: '10%',
            padding: '5px'

        };
        const finalstyle = { ...defaultStyles, ...styles };
        return <React.Fragment>
            {
                isLink ?
                    <Link className={className} style={finalstyle} to={to} >
                        X
                    </Link> :
                    <div className={className} onClick={onClick} style={finalstyle}>
                        X
                </div>
            }
        </React.Fragment>

    }
}

CloseButton.propTypes = {
    className: PropTypes.string,
    styles: PropTypes.object,
    isLink: PropTypes.bool,
    to: PropTypes.string,
    onClick: PropTypes.func
};

CloseButton.defaultProps = {
    isLink: false,

};

export default CloseButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/CloseButton/CloseButton.js